import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import AddCardComponent from './add-card.component';
import UpdateCardComponent from './update-card.component';
import UpdateCardBasicInfoComponent from './update-card-basic-info.component';


export const CardComponent = ({cardDetailInfo,layouts,isModalOpen,isModalProductOpen,handleOpenModal,handleCloseModal,
  handleOpenProductModal,handleCloseProductModal,onSelect,additionButtons,setPageSize,productsPaginationData,productColumnDefs,categories,products,categoriesPaginationData,setPageData,categoryColumnDefs,changeCardFile,cardTemplate,handleInnerFormChange,deletewebPageCardItem,typeData,cardTypes,handleFormChange,webPageCards,id,cardValues,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Card Information',
        component:<AddCardComponent 
        handleFormChange={handleFormChange}
        webPageCards={webPageCards}
        cardValues={cardValues}
        typeData={typeData}
        cardTypes={cardTypes}
        deletewebPageCardItem={deletewebPageCardItem}
        handleInnerFormChange={handleInnerFormChange}
        changeCardFile={changeCardFile}
        categoryColumnDefs={categoryColumnDefs}
        setPageData={setPageData}
        categoriesPaginationData={categoriesPaginationData}
          products={products}
          categories={categories}
          productColumnDefs={productColumnDefs}
          productsPaginationData={productsPaginationData}
          onSelect={onSelect}
          additionButtons={additionButtons}
          isModalOpen={isModalOpen}
          isModalProductOpen={isModalProductOpen}
          handleOpenModal ={handleOpenModal}
          handleCloseModal ={handleCloseModal}
          handleOpenProductModal ={handleOpenProductModal}
          handleCloseProductModal ={handleCloseProductModal}
          layouts={layouts}
          
        />,
        isVisible: id == 0 ? true : false,
    },
    {
      id:2,
      title:'Update Card Basic Information',
      component:<UpdateCardBasicInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      layouts={layouts}
      webPageCards={webPageCards}
      cardTypes={cardTypes}
      />,
      isVisible: id > 0 ? true : false,
  },
    {
      id:3,
      title:'Update Card Details',
      component:<UpdateCardComponent 
      cardDetailInfo={cardDetailInfo}
      cardTemplate ={cardTemplate}
    cardValues={cardValues}
    handleFormChange={handleFormChange}
    deletewebPageCardItem={deletewebPageCardItem}
    changeCardFile={changeCardFile}
    categoryColumnDefs={categoryColumnDefs}
    setPageData={setPageData}
    categoriesPaginationData={categoriesPaginationData}
      products={products}
      categories={categories}
      productColumnDefs={productColumnDefs}
      productsPaginationData={productsPaginationData}
      setPageSize={setPageSize}
      onSelect={onSelect}
      additionButtons={additionButtons}
      isModalOpen={isModalOpen}
      isModalProductOpen={isModalProductOpen}
      handleOpenModal ={handleOpenModal}
      handleCloseModal ={handleCloseModal}
      handleOpenProductModal ={handleOpenProductModal}
      handleCloseProductModal ={handleCloseProductModal}
      webPageCards={webPageCards}
      handleInnerFormChange={ handleInnerFormChange}
      layouts={layouts}
      cardTypes={cardTypes}
      />,
      isVisible: id > 0 ? true : false,
  },
    
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
            <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default CardComponent;
